/**
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2025-02-17 17:00:33
 */

import {type AnySchema, object, string} from 'yup';

// helpers
import {genericFieldsSchema, HandleProps} from '~/helpers/form-fields';

// types
import type {ProfessionalLetterField, ProfessionalLetterFields} from './fields-info';

export type ProfessionalLetterProps = HandleProps<ProfessionalLetterFields>

export const schema = object<ProfessionalLetterFields, Record<ProfessionalLetterField, AnySchema>>()
  .shape({
    postage_type: string().required('Postage Type is required'),
    ...genericFieldsSchema,
  });
